import * as TermsByOrganization from '../../services/api/termsByOrganizationId'

import { useApiRequest } from '../useApiRequest'

export function useGetTermsByOrganization ( organizationId ) {
  const { data, loading, error } = useApiRequest(TermsByOrganization.fetchAll( organizationId ))
  return { data, loading, error }
}
